import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TokensService } from '../../backend/api/tokens.service';
import { BaseComponent } from '../../core/components/base/base.component';
import { AuthService } from '../../core/services/auth.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends BaseComponent implements OnInit {
  form!: UntypedFormGroup;
  isLoading = false;
  showSplash = true;
  showLogin = false;
  isFormReady = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private tokensService: TokensService,
    private t: TranslateService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
  }

  ngOnInit() {
    // Initialize form
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      password: new UntypedFormControl('', [Validators.required]),
    });
    this.isFormReady = true;

    // Show splash screen for 3 seconds
    setTimeout(() => {
      this.showSplash = false;
      // Add a small delay before showing login to allow for transition
      setTimeout(() => {
        this.showLogin = true;
      }, 500);
    }, 3000);
  }

  submitForm() {
    if (!this.form.valid) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
      return;
    }

    this.isLoading = true;

    this.tokensService
      .loginPost({
        loginRequestDto: {
          email: this.form.value.email,
          password: this.form.value.password,
        },
      })
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.authService.setAuth(res);
          this.router.navigate(['']);
        },
        (err) => {
          this.isLoading = false;
          this.errorHandler(err);
        }
      );
  }
}
